export default "__VITE_ASSET__B0U_ifcx__"